import { Badge, Button, Card, Col, Divider, Empty, Form, Image, Input, InputNumber, Modal, Popconfirm, Row, Select, Space, Tag, message } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Add from './Add';
import AddPolka from './AddPolka';
import { AppstoreAddOutlined, ArrowDownOutlined, ArrowRightOutlined, ArrowUpOutlined, DeleteOutlined, InboxOutlined, PlusOutlined, SaveOutlined, SwapOutlined } from '@ant-design/icons';
import { Option } from 'antd/es/mentions';
import { MAIN_URL } from '../../../../Constants';
import emptyimage from '../../../../assets/images/emptyimage.jpg';
import TextArea from 'antd/es/input/TextArea';
import css from './Sections.module.css';

function Sections() {
    const [sections, setSections] = useState([]);
    const [sectionModal, setSectionModal] = useState(false);
    const [polkaModal, setPolkaModal] = useState(false);
    const [render, setRender] = useState(false);
    const [selectedShelf, setSelectedShelf] = useState(null);
    const [shelfModal, setShelfModal] = useState(false);
    const [products, setProducts] = useState([]);
    const [variant, setVariant] = useState(null);
    let [chiqimModal, setChiqimModal] = useState(false);
    let [chiqimcount, setChiqimcount] = useState(0);

    let [fromsec, setFromsec] = useState(null);
    let [tosec, setTosec] = useState(null);
    let [fromshelf, setFromshelf] = useState(null);
    let [toshelf, setToshelf] = useState(null);
    let [perenosModal, setPerenosModal] = useState(false);

    let [sendata, setSendata] = useState([])
    const { id } = useParams();

    useEffect(() => {
        axios.get(`section/${id}`)
            .then((res) => setSections(res.data))
            .catch(() => message.error("Seksiyalarni yuklashda xatolik"));

        axios.get('products').then(res => {
            setProducts(res.data)
            setVariant(res.data);
        }).catch(() => message.error("Tovarlarni yuklashda xatolik"));
    }, [render, id]);

    const handleDeleteSection = (secId) => {
        axios.delete('section/' + secId).then(() => {
            setRender(!render);
            message.success("Seksiya o'chirildi");
        }).catch(() => message.error("O'chirishda xatolik"));
    };

    const handleDeleteShelf = (shelfId) => {
        axios.delete('shelves/' + shelfId).then(() => {
            setRender(!render);
            message.success("Polka o'chirildi");
        }).catch(() => message.error("O'chirishda xatolik"));
    };
    return (
        <>
            <Modal title={"Chiqim"} open={chiqimModal} onCancel={() => setChiqimModal(false)} footer={null} width={'60%'}>
                <h3 className={css.modalPaneTitle}>Polka: {selectedShelf?.name}</h3>
                <Divider style={{ margin: '12px 0' }} />
                {
                    selectedShelf && selectedShelf.inventories && selectedShelf.inventories.length > 0 ? (
                        <div className={css.lineList}>
                            {selectedShelf.inventories.map(item => (
                                <div key={item.id} className={css.lineRow}>
                                    <span className={css.lineName}>{item.nameuz} {item.parametr} <small>{item.country_name} {item.manufacturer_name} · {item.quantity} ta</small></span>
                                    <Input type='number' style={{ width: 100 }} min={1} max={item.quantity} onInput={(e) => {
                                        let val = Number(e.target.value);
                                        setChiqimcount(Math.floor(Number(val)));
                                        if (val > Number(item.quantity)) {
                                            alert("Mavjud miqdordan ko'p kiritish mumkin emas");
                                            e.target.value = Math.floor(Number(item.quantity));
                                        }
                                    }} />
                                    <Button type="primary" onClick={() => {
                                        axios.post('chiqim/' + item.id, { quantity: chiqimcount }).then(() => {
                                            message.success("Tovar polkadan chiqarildi");
                                            setChiqimcount(0);
                                            setRender(!render);
                                            setChiqimModal(false);
                                        }).catch(() => message.error("Tovar chiqarishda xatolik"));
                                    }} icon={<SaveOutlined />} />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <Empty description="Bu polkada chiqariladigan tovar yo'q" />
                    )
                }

            </Modal>
            <Modal title="Kirim" open={shelfModal} onCancel={() => setShelfModal(false)} footer={null} width={'60%'}>
                <Row style={{ marginBottom: 16 }} gutter={16}>
                    <Col span={12}>
                        <div className={css.modalPane}>
                            <h3 className={css.modalPaneTitle}>Tanlangan tovarlar — Polka #{selectedShelf?.id}</h3>

                            <Divider style={{ margin: '12px 0' }} />
                            {
                                sendata.length > 0 ? (
                                    <div className={css.lineList}>
                                        {sendata.map(item => (
                                            <div key={item.inventory_id} className={css.lineRow}>
                                                <span className={css.lineName}>{item.name} {item.parametr}</span>
                                                <InputNumber style={{ width: 100 }} min={1} defaultValue={item.quantity} onChange={(val) => {
                                                    let updated = sendata.map(d => {
                                                        if (d.inventory_id === item.inventory_id) {
                                                            return { ...d, quantity: val };
                                                        } return d;
                                                    });
                                                    setSendata(updated);
                                                }} />
                                                <Button type="primary" danger onClick={() => {
                                                    let filtered = sendata.filter(d => d.inventory_id !== item.inventory_id);
                                                    setSendata(filtered);
                                                }} icon={<DeleteOutlined />} />
                                            </div>
                                        ))}
                                        <Button type="primary" onClick={() => {
                                            axios.post('addinventory/' + selectedShelf?.id, sendata).then(() => {
                                                message.success("Tovar polkaga qo'shildi");
                                                setSendata([]);
                                                setRender(!render);
                                            }).catch(() => message.error("Tovar qo'shishda xatolik"));
                                        }} style={{ marginTop: 12 }}>Saqlash</Button>

                                    </div>
                                ) : (
                                    <Empty description="Hali tovar qo'shilmagan" />
                                )

                            }
                        </div>
                    </Col>
                    <Col span={12}>
                        <Input.Search
                            placeholder="Tovar nomi, shtrix kod yoki SKU bo'yicha qidirish"
                            onInput={(e) => {
                                let searchTerm = e.target.value;
                                let filtered = products;

                                if (variant.length > 0) {
                                    filtered = variant.filter(p =>
                                        p.product_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        p.barcode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        p.sku?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        p.country_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        p.manufacturer_name?.toLowerCase().includes(searchTerm.toLowerCase())
                                    );
                                    setProducts(filtered);
                                }

                            }}
                            size="large"

                        />
                        <Divider />

                        {
                            products.length > 0 && (
                                <div className={css.lineList}>
                                    {products.map(product => (
                                        <div key={product.id} className={css.lineRowSearch}>
                                            <Image className={css.lineThumb} src={product.img ? MAIN_URL + '/' + product.img : emptyimage} width={48} height={48} />
                                            <span className={css.lineName}>{product.product_name} {product.parametr} <small>{product.country_name} · {product.manufacturer_name}</small></span>
                                            <Tag className={css.skuTag}>{product.sku}</Tag>
                                            <Button type="primary" onClick={() => {
                                                let data = {
                                                    inventory_id: product.id,
                                                    shelf_id: selectedShelf.id,
                                                    name: product.product_name,
                                                    barcode: product.barcode,
                                                    parametr: product.parametr,
                                                    quantity: 1
                                                };

                                                setSendata([data, ...sendata]);

                                                // axios.post('addinventory', data).then(() => {
                                                //     message.success("Tovar polkaga qo'shildi");
                                                //     setRender(!render);
                                                // }).catch(() => message.error("Tovar qo'shishda xatolik"));
                                            }} icon={<ArrowRightOutlined />} />
                                        </div>
                                    ))}
                                </div>
                            )

                        }
                    </Col>
                </Row>




            </Modal >


            <Modal title="Perenos" open={perenosModal} onCancel={() => setPerenosModal(false)} footer={null}>
                <Form layout="vertical" onFinish={(v)=>{
                    v.type = 'move'
                    axios.post('perenossh', v).then(()=>{
                        message.success("Tovar muvaffaqiyatli ko'chirildi");
                        setPerenosModal(false);
                        setRender(!render);
                    }).catch(() => message.error("Ko'chirishda xatolik"));
                }}>
                    <Form.Item label="Qayerdan">
                        <Select placeholder="Seksiyani tanlang" onChange={(sect)=>{
                            setFromsec(sections.find(s=>s.id === sect));
                        }}>
                            {sections.map(sec => (
                                <Option key={sec.id} value={sec.id}>{sec.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Qayerdan polka" name={'from_shelf_id'}>
                        <Select placeholder="Polkani tanlang" onChange={(shelf)=>{
                            setFromshelf(fromsec.shelves.find(sh=>sh.id === shelf));
                        }} disabled={!fromsec}>
                            {fromsec?.shelves?.map(sh => (
                                <Option key={sh.id} value={sh.id}>{sh.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Qayerga">
                        <Select placeholder="Seksiyani tanlang" onChange={(sect)=>{
                            setTosec(sections.find(s=>s.id === sect));
                        }}>
                            {sections.map(sec => (
                                <Option key={sec.id} value={sec.id}>{sec.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Qayerga polka" name={'to_shelf_id'}>
                        <Select placeholder="Polkani tanlang" onChange={(shelf)=>{
                            setToshelf(tosec.shelves.find(sh=>sh.id === shelf));
                        }} disabled={!tosec}>
                            {tosec?.shelves?.map(sh => (
                                <Option key={sh.id} value={sh.id}>{sh.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Qaysi maxsulot" name={'var_id'}>
                        <Select placeholder="Maxsulotni tanlang" onChange={(val)=>{
                            let inv = fromshelf.inventories.find(i=>i.var_id === val);
                            setSendata([{inventory_id: inv.var_id, name: inv.nameuz, quantity: 1}]);
                        }} disabled={!fromshelf}>
                            {fromshelf?.inventories?.map(inv => (
                                <Option key={inv.id} value={inv.var_id}>{inv.nameuz} | {inv.parametr} | {inv.country_name} | {inv.manufacturer_name} | {inv.quantity}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Miqdor" name={'quantity'}>
                        <InputNumber min={1} disabled={!fromshelf} onChange={(val)=>{
                            setChiqimcount(val);
                        }} />
                    </Form.Item>
                    <Form.Item label="Izoh" name={'note'}>
                        <TextArea />
                    </Form.Item>
                    <Button htmlType='submit' type="primary" block>Yuborish</Button>
                </Form>
            </Modal>

            <Modal title="Seksiya qo'shish" open={sectionModal} onCancel={() => setSectionModal(false)} footer={null}>
                <Add wid={id} setR={setRender} r={render} />
            </Modal>
            <Modal title="Polka qo'shish" open={polkaModal} onCancel={() => setPolkaModal(false)} footer={null}>
                <AddPolka sections={sections} setR={setRender} r={render} />
            </Modal>

            <div className={css.toolbar}>
                <h3 className={css.toolbarTitle}><InboxOutlined /> Seksiyalar</h3>
                <Space wrap>
                    <Button icon={<SwapOutlined />} onClick={() => setPerenosModal(true)}>
                        Ko'chirish
                    </Button>
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => setSectionModal(true)}>
                        Seksiya qo'shish
                    </Button>
                    <Button type="primary" ghost icon={<AppstoreAddOutlined />} onClick={() => setPolkaModal(true)}>
                        Polka qo'shish
                    </Button>
                </Space>
            </div>

            {sections.length === 0 && <Empty description="Seksiyalar topilmadi" />}

            {
                sections.map((sec) => (
                    <Card
                        key={sec.id}
                        className={css.sectionCard}
                        title={<Space><InboxOutlined /> {sec.name} <Tag>{sec.shelves?.length || 0} polka</Tag></Space>}
                        extra={
                            <Popconfirm
                                placement="topLeft"
                                title="Bu seksiyani o'chirmoqchimisiz?"
                                description="Bu amalni qaytarib bo'lmaydi!"
                                okText="Ha, o'chirish"
                                cancelText="Bekor qilish"
                                onConfirm={() => handleDeleteSection(sec.id)}
                            >
                                <Button icon={<DeleteOutlined />} type="text" danger shape="circle" size="small" />
                            </Popconfirm>
                        }
                    >
                        {(!sec.shelves || sec.shelves.length === 0) && <Empty description="Polkalar yo'q" image={Empty.PRESENTED_IMAGE_SIMPLE} />}

                        <div className={css.shelfGrid}>
                            {sec.shelves?.map((shelf) => (
                                <Badge.Ribbon key={shelf.id} text={`${shelf.inventories?.length || 0} tovar`} color={shelf.inventories?.length ? 'green' : 'default'}>
                                    <Card
                                        type="inner"
                                        title={<span style={{ fontWeight: 600 }}>Polka: {shelf.name}</span>}
                                        actions={[
                                            <Button
                                                type="text"
                                                icon={<ArrowDownOutlined />}
                                                block
                                                onClick={() => { setShelfModal(true); setSelectedShelf(shelf); }}
                                                style={{ color: 'var(--success)' }}
                                            >Kirim</Button>,
                                            <Button
                                                type="text"
                                                icon={<ArrowUpOutlined />}
                                                block
                                                onClick={() => { setChiqimModal(true); setSelectedShelf(shelf); }}
                                                style={{ color: 'var(--warning)' }}
                                            >Chiqim</Button>,
                                            <Popconfirm
                                                placement="topLeft"
                                                title="Bu polkani o'chirmoqchimisiz?"
                                                description="Bu amalni qaytarib bo'lmaydi!"
                                                okText="Ha, o'chirish"
                                                cancelText="Bekor qilish"
                                                onConfirm={() => handleDeleteShelf(shelf.id)}
                                            >
                                                <Button block type="text" danger icon={<DeleteOutlined />} />
                                            </Popconfirm>
                                        ]}
                                    >
                                        {(!shelf.inventories || shelf.inventories.length === 0) ? (
                                            <div className={css.shelfEmpty}>Bu polka bo'sh</div>
                                        ) : (
                                            <div className={css.invList}>
                                                {shelf.inventories.map(inv => (
                                                    <div key={inv.id} className={css.invRow}>
                                                        <span>{inv.nameuz}</span>
                                                        <span className={css.qtyBadge}>{Math.floor(inv.quantity)}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </Card>
                                </Badge.Ribbon>
                            ))}
                        </div>
                    </Card>
                ))
            }
        </>
    );
}

export default Sections;
